import { render, staticRenderFns } from "./payments-taxes_es.vue?vue&type=template&id=564563ae&"
import script from "./payments-taxes_es.vue?vue&type=script&lang=js&"
export * from "./payments-taxes_es.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports